import {useCallback, useState} from 'react';

import {InternalSurveyModal} from 'shells/modal/internal-survey-modal/internal-survey-modal';

import {useFeedbackSubmit} from '../graphql/hooks/use-feedback-submit';

type NutshellSurveyOptions = {
    onClose?: () => void;
};

type NutshellSurveyResult = {
    isOpen: boolean;
    openSurvey: () => void;
    SurveyModal: React.ReactNode;
};

export function useNutshellSurvey(options?: NutshellSurveyOptions): NutshellSurveyResult {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const {feedbackSubmit} = useFeedbackSubmit();

    const openSurvey = () => {
        setIsOpen(true);
    };

    const closeSurvey = () => {
        setIsOpen(false);
        options?.onClose?.();
    };

    const handleSubmit = useCallback(
        (response: string) => {
            return feedbackSubmit({
                key: 'nutshell',
                response,
                uri: window.location.href,
            });
        },
        [feedbackSubmit]
    );

    const SurveyModal = isOpen ? (
        <InternalSurveyModal
            onClose={closeSurvey}
            title="We'd love your feedback on Nutshell"
            description={`What do you like most about Nutshell?\nWhat could be improved?\nAre there any features you wish existed?`}
            thumbnailIllustration='/include/images/nutshell-logo-full-color.svg'
            onSubmit={handleSubmit}
        />
    ) : null;

    return {
        isOpen,
        openSurvey,
        SurveyModal,
    };
}
